import loadable from '@loadable/component';
import { Routes, Route } from 'react-router-dom';
import Toasts from 'src/components/sections/toasts';
import MainLayout from 'src/layout/main';
import styles from './index.sass';
import AppRoutes from 'src/routes';
import i18nConfig from 'src/config/i18n.json';
import AuthLayout from 'src/layout/auth';
import { useAuth } from 'src/contexts/auth';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import axios from 'axios';
import LoadingIndicator from 'src/components/ui/loading_indicator';
import { useToast } from 'src/contexts/toast';
import errorHandler from 'src/utils/error_handler';
import LoadingOverlay from 'src/components/loading_overlay';

const NotFoundMainPage = loadable(async () => await import('src/pages/main/404'));
const NotFoundAuthPage = loadable(async () => await import('src/pages/auth/404'));

function Layout() {
	const navigate = useNavigate();
	const { user, login } = useAuth();
	const { toast } = useToast();
	const [loading, setLoading] = useState(true);

	function generateRoutes(routes) {
		const output: any[] = [];

		for (let i = 0; i < routes.length; i++) {
			const route = routes[i];

			const children: any = route.children?.length > 0 ? generateRoutes(route.children) : null;

			if (route.noRoute) {
				// eslint-disable-next-line react/jsx-no-undef
				output.push(<React.Fragment key={`route-${route.path}-${i}`}>{children}</React.Fragment>);
			} else {
				output.push(
					<Route
						key={`route-${route.path}-${i}`}
						path={route.path || undefined}
						index={(route.path === '') as true}
						element={route.element ? <route.element {...(route.pageProps || {})} /> : undefined}
					>
						{children}
					</Route>
				);
			}
		}

		return output;
	}

	useEffect(() => {
		axios
			.get(`${process.env.API_URL}/auth/user`, { withCredentials: true })
			.then((res) => {
				if (res.status === 200) {
					setLoading(false);

					login(res.data);
				}
			})
			.catch((err) => {
				setLoading(false);

				navigate('/auth/login');

				if (err.code === 'ERR_NETWORK') {
					errorHandler('ورود به حساب کاربری', 'ERR_NETWORK', toast);
				}
			});
	}, []);

	if (loading) {
		return <LoadingOverlay />;
	}

	return (
		<div className={styles.layout}>
			<Toasts />

			<Routes>
				{i18nConfig.languageKeys.map((key) => {
					const path = key === i18nConfig.defaultLanguage ? '/' : `/${key}`;

					return (
						<Route path={path} key={key}>
							<Route path={'auth'} element={<AuthLayout />}>
								{generateRoutes(AppRoutes.auth)}
								<Route path={'*'} element={<NotFoundAuthPage />} />
							</Route>

							{user && (
								<Route element={<MainLayout />}>
									{user && generateRoutes(AppRoutes.main)}
									<Route path={'*'} element={<NotFoundMainPage />} />
								</Route>
							)}
						</Route>
					);
				})}
			</Routes>
		</div>
	);
}

export default Layout;
